export default "__VITE_ASSET__DK31cK3p__"